import React from 'react'
import {
  Button,
  Container,
  Popup,
  TextTitle,
  TextBody,
  State
} from '@pmi/pmi-iqos-ds-react'

const InvalidAddressPopup = ({
  isOpen,
  onClose,
  onAccept,
  loading,
  translations
}) => {
  return (
    <Popup isOpen={isOpen} onCloseHandler={onClose}>
      <Container
        flexDirection={Container.flexDirections.column}
        display={Container.displays.flex}
        alignItems={Container.alignItemsValues.center}>
        <Container pb="6">
          <State state={State.states.newWarningGray} size={State.sizes.xxl} />
        </Container>
        <Container
          flexDirection={Container.flexDirections.column}
          display={Container.displays.flex}
          alignItems={Container.alignItemsValues.center}>
          <Container pb="6">
            <TextTitle heading={TextTitle.headings.h4}>
              {translations.tk_attention}
            </TextTitle>
          </Container>
          <Container
            pb="14"
            flexDirection={Container.flexDirections.column}
            display={Container.displays.flex}
            alignItems={Container.alignItemsValues.center}>
            <TextBody>{translations.tk_invalidAddress}</TextBody>
            <TextBody>{translations.tk_sureToProceed}</TextBody>
          </Container>
        </Container>
        <Container pb="4" fullWidth>
          <Button
            variant={Button.variants.primary}
            text={translations.tk_popupSubmitBtn}
            onClickHandler={onAccept}
            loading={loading}
            fullWidth
          />
        </Container>
        <Button
          variant={Button.variants.secondary}
          text={translations.tk_modifyAddress}
          onClickHandler={onClose}
          loading={loading}
          fullWidth
        />
      </Container>
    </Popup>
  )
}

export default InvalidAddressPopup
